import React from "react";
import InputPrePostFixComponent from "../../common-components/inputPrePostFix";
import InputPrePostBtnComponent from "../../common-components/inputPrePostBtn";

const AutobetControls = ({ autoForm, setAutoForm, maxBetAmt, disabled, remainingBet }) => {

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const val = value;
    if (/^\d*$/.test(val)) {
      
    }
   
    if(name == 'numOfBet') {
      if(value <= 100) {
        if (/^\d*$/.test(val)) {
          setAutoForm((prev) => ({ ...prev, [name]: value }));
        }
        
      }
    } else {
      if (/^\d*$/.test(val)) {
        setAutoForm((prev) => ({ ...prev, [name]: value }));
      }
     
    }
  };

  const handlePostClick = (name, value, type) => {
    console.log(381, name, value, type)
    
    if(type == "reset") {
      setAutoForm((prev) => ({ ...prev, [name]: 0 }));
    } else if(type == 'increase') {
      
      if(name == 'onWin' && value > 0) {
        
      
        setAutoForm((prev) => ({ ...prev, ['betAmount']:  Number(autoForm['betAmount']) + (Number(autoForm['betAmount'])*Number(value) / 100)}));
      } else if(name == 'onLoss' && value > 0) {console.log((autoForm['betAmount']*value / 100))
        setAutoForm((prev) => ({ ...prev, ['betAmount']:  Number(autoForm['betAmount']) - (Number(autoForm['betAmount'])*Number(value) / 100)}));

      }
      
    } else if(type == 'up') {
     
      if(name == 'numOfBet') {
        if(value < 100) {
          setAutoForm((prev) => ({ ...prev, [name]: value+1 }));
        }
      } else {
        setAutoForm((prev) => ({ ...prev, [name]: value }));
      }
    } else if(type == 'down') {
      if(value > 0) {
        setAutoForm((prev) => ({ ...prev, [name]: value-1 }));
      }
      
    } else {
     
      if((Number(type) * Number(autoForm.betAmount)) >= maxBetAmt) {
        setAutoForm((prev) => ({ ...prev, betAmount: Number(maxBetAmt) }));

      } else {
        setAutoForm((prev) => ({ ...prev, betAmount: (Number(type) * Number(autoForm.betAmount)) }));

      }
    }
  };

  return (
    <div className={disabled ? "opacity-50 disabled:cursor-not-allowed": ""}>
      <InputPrePostFixComponent
        name={"betAmount"}
        label={"Bet amount"}
        type={"number"}
        placeholder={"Enter Bet Amount"}
        value={autoForm.betAmount}
        handleChange={handleChange}
        required
        postOne={"1/2"}
        postTwo={"2"}
        handlePostClick={handlePostClick}
        icon={true}
        postType={"number"}
        disabled={disabled}
      />
      <div className="d-flex">
      <InputPrePostFixComponent
        name={"cashOutAt"}
        label={"Cashout At"}
        type={"number"}
        placeholder={"Enter Cashout At"}
        value={autoForm.cashOutAt}
        handleChange={handleChange}
        required
        handlePostClick={handlePostClick}
        icon={false}
        postType={"arrow"}
        disabled={disabled}
      />
       <InputPrePostFixComponent
        name={"numOfBet"}
        label={"Number Of Bet"}
        type={"number"}
        placeholder={"Enter Number Of Bet"}
        value={autoForm.numOfBet}
        handleChange={handleChange}
        required
        handlePostClick={handlePostClick}
        icon={true}
        postType={false}
        disabled={disabled}
        remainingBet={remainingBet}
      />
      </div>
      
      <InputPrePostBtnComponent
        name={"onWin"}
        label={"On Win"}
        type={"number"}
        placeholder={"Enter on Win"}
        value={autoForm.onWin}
        handleChange={handleChange}
        required
        handlePostClick={handlePostClick}
        icon={true}
        postType={"ResetInc"}
        disabled={disabled}
       />
       <InputPrePostBtnComponent
        name={"onLoss"}
        label={"On Loss"}
        type={"number"}
        placeholder={"Enter on Loss"}
        value={autoForm.onLoss}
        handleChange={handleChange}
        required
        handlePostClick={handlePostClick}
        icon={true}
        postType={"ResetInc"}
        disabled={disabled}
       />
        <InputPrePostFixComponent
          name={"stopProfit"}
          label={"Stop on Profit"}
          secondLabel={"$0.00"}
          type={"number"}
          placeholder={"Enter Stop on Profit"}
          value={autoForm.stopProfit}
          handleChange={handleChange}
          required
          handlePostClick={handlePostClick}
          icon={true}
          postType={false}
          disabled={disabled}
        />
         <InputPrePostFixComponent
          name={"stopLoss"}
          label={"Stop on Loss"}
          secondLabel={"$0.00"}
          type={"number"}
          placeholder={"Enter Stop on Loss"}
          value={autoForm.stopLoss}
          handleChange={handleChange}
          required
          handlePostClick={handlePostClick}
          icon={true}
          postType={false}
          disabled={disabled}
        />
         <InputPrePostFixComponent
          name={"profitWin"}
          label={"Profit on Win"}
          secondLabel={"$0.00"}
          type={"number"}
          placeholder={"Enter Profit on Win"}
          value={autoForm.profitWin}
          handleChange={handleChange}
          required
          handlePostClick={handlePostClick}
          icon={true}
          postType={false}
          disabled={true}
        />
    </div>
  );
};

export default AutobetControls;
